import { render, staticRenderFns } from "./jiyangList.vue?vue&type=template&id=0c566c95&scoped=true&"
import script from "./jiyangList.vue?vue&type=script&lang=js&"
export * from "./jiyangList.vue?vue&type=script&lang=js&"
import style0 from "./jiyangList.vue?vue&type=style&index=0&id=0c566c95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c566c95",
  null
  
)

export default component.exports